
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/visita-les-instalacions",
      function () {
        return require("private-next-pages/corporatiu/visita-les-instalacions/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/visita-les-instalacions"])
      });
    }
  